export default class Cache {
	data = [];

	set(key, value) {
		this.data[key] = value;
		return value;
	}

	get(key) {
		return this.data[key];
	}

	has(key) {
		return !!this.get(key);
	}

	empty() {
		this.data = [];
	}
}



// WEBPACK FOOTER //
// ./src/utils/cache/index.js